import React from 'react'
import { useCoachChat } from './CoachChatContext'
import CoachTextMessages from './CoachTextMessages'
import CoachTextMessageEditor from './CoachTextMessageEditor'

/**
 * CoachTextChatWrap component - wraps text chat functionality
 * Based on the candidate text chat wrap but adapted for coach use
 *
 * @param {Object} props
 * @param {Array} props.messages - Array of chat messages
 * @param {Object} props.candidate - The candidate being chatted with
 * @param {Object} props.selectedCandidate - The selected candidate for this chat slot
 */
const CoachTextChatWrap = ({ messages, candidate, selectedCandidate }) => {
  const { getBackgroundClass, getDarkModeClasses } = useCoachChat()

  return (
    <div
      className={`flex h-full min-h-0 w-full flex-col ${getBackgroundClass()}`}
    >
      {/* Divider line */}
      <div
        className={`h-px w-full border-t ${getDarkModeClasses('border-zinc-400', 'border-gray-600')}`}
      ></div>

      {/* Display chat messages */}
      <div className="min-h-0 flex-1 overflow-hidden">
        <CoachTextMessages
          messages={messages}
          selectedCandidate={selectedCandidate}
        />
      </div>

      {/* Message input and send button */}
      <CoachTextMessageEditor
        candidate={candidate}
        selectedCandidate={selectedCandidate}
      />
    </div>
  )
}

export default CoachTextChatWrap
